// extracted by mini-css-extract-plugin
export var flucs = "RaceFiltersSkeleton-module--flucs--70620";
export var sort = "RaceFiltersSkeleton-module--sort--33cec";
export var speedMap = "RaceFiltersSkeleton-module--speedMap--9ae44";
export var tips = "RaceFiltersSkeleton-module--tips--5cf5c";